import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import type { ActiveCountResponse, ProjectsTasksBadges } from '../../pages/ProjectsList/types';

const initialState = {
    tasks: <ProjectsTasksBadges | null>null,
    backgroundActivity: <ActiveCountResponse | null>null,
};

const badgesSlice = createSlice({
    name: 'badges',
    initialState,
    reducers: {
        setTaskBadges: (state, { payload }: PayloadAction<{ tasksBadges: ProjectsTasksBadges }>) => {
            const { tasksBadges } = payload;

            state.tasks = castDraft(tasksBadges);
        },
        setBackgroundActivityBadges: (
            state,
            { payload }: PayloadAction<{ backgroundActivityBadges: ActiveCountResponse }>,
        ) => {
            const { backgroundActivityBadges } = payload;

            state.backgroundActivity = backgroundActivityBadges;
        },
    },
});

export default badgesSlice.reducer;

const getBadgeStatus = createAction(
    'badge/getBadgeStatus',
    (payload: { projectId: string; branchId: string | null }) => ({
        payload,
    }),
);

const { setBackgroundActivityBadges, setTaskBadges } = badgesSlice.actions;

export const badgeActions = {
    getBadgeStatus,
    setBackgroundActivityBadges,
    setTaskBadges,
};
